import { render, staticRenderFns } from "./BuyKeyPal.vue?vue&type=template&id=62b0828a&scoped=true&"
import script from "./BuyKeyPal.vue?vue&type=script&lang=js&"
export * from "./BuyKeyPal.vue?vue&type=script&lang=js&"
import style0 from "./BuyKeyPal.vue?vue&type=style&index=0&id=62b0828a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b0828a",
  null
  
)

export default component.exports